<template>
  <div>
    <div class="playerbg">
      <div class="header" style="line-height: 30px;">
        <h1>{{ data.title }}</h1>
        <div class="time">
          <a-icon type="clock-circle" />&ensp;{{(data.beginTime || "").slice(0, 10)}} ~ {{ (data.endTime || "").slice(0, 10) }}
          &ensp;&ensp;&ensp;&ensp;
          <a-icon type="environment" />&ensp;{{data.address || "未知"}}
        </div>
        <div class="time">
          <span v-for="(item,index) in data.company" :key="index">
            {{ item.name }}：
            <span v-for="(text,i) in item.data" :key="i">{{text}}&ensp;</span>
          </span>
        </div>
     </div>
    </div>
    <div class="nav-box">
      <div class="nav-item">
        <div @click="toUrl('ActivitySign')" :class="'item-list ' + hoverFun('ActivitySign')">
          培训报名
        </div>
        <div @click="toUrl('ActivitySchedule')" :class="'item-list ' + hoverFun('ActivitySchedule')">
          日程安排
        </div>
        <div @click="toUrl('ActivityLecturer')" :class="'item-list ' + hoverFun('ActivityLecturer')">
          培训讲师
        </div>
        <div @click="toUrl('ActivityNotice')" :class="'item-list ' + hoverFun('ActivityNotice')">
          活动公告
        </div>
        <div @click="toUrl('ActivityCheck')" :class="'item-list ' + hoverFun('ActivityCheck')">
          考核
        </div>
        <!-- <div class="item-list">
          成绩
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import matchFun from '@comm/utils/matchFun'
export default {
  name: 'ExaminHead',
  data () {
    return {
      matchFun,
      data: {
        title: '',
        company: []
      }
    }
  },
  created: function () {
    this.findData()
  },
  methods: {
    findData () {
      this.$api.examin.examinPointDetail({id: this.$route.query.id}).then(res => {
        if (res.status === 0) {
          this.data = res.data
          this.data.company = JSON.parse(res.data.company)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    hoverFun (url) {
      if (this.$route.name === url) {
        return 'item-hover'
      }
      return ''
    },
    toUrl (url) {
      this.$router.push('/' + url + '?id=' + this.$route.query.id + '&programId=' + this.$route.query.programId)
    }
  }
}
</script>

<style lang="scss" scoped>
.playerbg{
  height: 200px;
  padding-top: 20px;
  background-image: url('../../../assets/weapon/playertopbg.png');
}
.header{
  width: 1200px;
  padding: 30px 0 20px 0;
  margin: 0 auto;
  padding: 40px;

}
.header h1{
  text-align: center;
  color: white;
  font-weight: bold;
}

.header .time{
  text-align: center;
  color: white;
}
.nav-box {
  width: 100%;
  height: 60px;
  background: rgb(226, 226, 226);
}
.nav-item{
  width: 1200px;
  margin: 0 auto;
}
.item-list{
  width: 150px;
  text-align: center;
  line-height: 60px;
  font-size: 16px;
  float: left;
  color: black;
  cursor: pointer;
}
.item-hover {
  background: #244e8f;color: white;
}
</style>



// WEBPACK FOOTER //
// src/daoba-match/views/program/components/ActivityHead.vue